import { List, ListSubheader, ListItem, ListItemText } from '@mui/material';
import { SnapshotMonitor } from 'types';

interface Props {
  monitors: SnapshotMonitor[] | undefined;
  selectedMonitorId: number;
  handleMonitorClicked: (monitorId: number) => void;
}

const MonitorList = ({
  monitors,
  selectedMonitorId,
  handleMonitorClicked,
}: Props) => {
  return (
    <List>
      <ListSubheader>Monitors</ListSubheader>
      {monitors?.map((monitor, idx) => (
        <ListItem
          button
          key={idx}
          selected={selectedMonitorId === monitor.id}
          onClick={() => handleMonitorClicked(monitor.id)}
        >
          <ListItemText key={monitor.id}>{monitor.name}</ListItemText>
        </ListItem>
      ))}
    </List>
  );
};

export default MonitorList;
